import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl} from './Handler.js'
import store from '../store/index'

export function _getAll(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/licenses/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getMyLicenses(){

    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getUrl()}/licenses/myLicenses`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
